import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@clerk/react'
import { AuthLoadingScreen } from './AuthLoadingScreen'

/**
 * Route-table auth guard for app surfaces.
 *
 * Lives in the route table on purpose: before this existed, auth was applied
 * only INSIDE the `/` element, so nothing at the definition site of
 * `/reading` revealed that it was unguarded — which is how anonymous visitors
 * could reach the reading flow and draw a card.
 *
 * ⚠️ Never redirect before Clerk has loaded. `isSignedIn` is false during
 * hydration, so an eager redirect ejects returning users to the landing page.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isSignedIn, isLoaded } = useAuth()

  if (!isLoaded) return <AuthLoadingScreen />

  if (!isSignedIn) return <Navigate to="/" replace />

  return <>{children}</>
}
